import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 402.07 402.07"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "401.07",
      height: "401.07",
      x: ".5",
      y: ".5",
      rx: "50",
      ry: "50",
      style: {"fill":"#57bbeb","stroke":"#000","stroke-miterlimit":"10"}
    }, null, -1),
    _createElementVNode("g", { "data-name": "레이어 1" }, [
      _createElementVNode("g", { "data-name": "Group 24" }, [
        _createElementVNode("path", {
          d: "m80.06 272.68-1.17.8c23.73 43.74 68.63 73.29 119.87 73.29 76.2 0 137.92-65.21 137.92-145.56 0-22.13-9.17-40.76-20.01-54.88-14.41-18.78-34.93-27.8-55.39-27.95-16.88-.15-34.35 5.53-46.65 16.67-14.05 12.74-17.18 29.11-20.82 55.68-4 29.11-27.44 49.2-57.57 49.2-39.01 0-63.17-24.02-61.57-60.77.15-2.55.36-5.09.8-7.57 7.35-43.38 54-88.14 124.16-87.99 47.09 0 82.46 10.55 117.83 46.14l1.17-.8C294.9 85.2 250.07 55.65 198.76 55.65c-76.13 0-137.92 65.21-137.92 145.56 0 22.12 9.17 40.76 20.02 54.87 14.34 18.78 34.94 27.73 55.39 27.95 16.89.22 34.35-5.53 46.65-16.67 14.05-12.74 17.18-29.11 20.82-55.68 4-29.11 27.51-49.2 57.57-49.2 39.08 0 63.25 24.02 61.64 60.77-.14 2.55-.36 5.1-.8 7.57-7.5 43.38-53.93 88.14-124.24 87.99-47.09 0-82.46-10.55-117.83-46.14",
          "data-name": "Fill 22",
          style: {"fill":"#051766","fill-rule":"evenodd"}
        })
      ])
    ], -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "KE-logo"}) } }